// extracted by mini-css-extract-plugin
export default {"fullScreen":"ErrorPage_fullScreen__zwVT5"};